export function possuiMensagemDeErro(error : any){
    return error && error.response &&
        error.response.data &&
        error.response.data.validation &&
        error.response.data.validation[0] &&
        error.response.data.validation[0].message
}